import AppConfigurationBPM from 'bpm/components/configuration/AppConfiguration'
import MainPageBPM from 'bpm/pages/MainPage'
import AppConfiguration from 'components/configuration/AppConfiguration'
import MainPage from 'pages/MainPage'
import React from 'react'
import ReactDOM from 'react-dom'
import * as serviceWorker from 'serviceWorkerRegistration'

/**
 * Global error handler to suppress ResizeObserver loop errors.
 *
 * The "ResizeObserver loop completed with undelivered notifications" error is benign
 * and occurs when the browser cannot deliver all resize observations within a single
 * animation frame. This is common in complex UIs with multiple observers and does not
 * affect functionality.
 *
 * While we have fixed our custom ResizeObserver hooks to use requestAnimationFrame,
 * third-party libraries (Material UI, CKEditor, etc.) may still trigger this error.
 * This global handler serves as a safety net to prevent console spam.
 *
 * Reference: https://github.com/WICG/resize-observer/issues/38
 */
const resizeObserverErrorHandler = (event: ErrorEvent) => {
    if (event.message === 'ResizeObserver loop completed with undelivered notifications.') {
        event.stopImmediatePropagation()
        return
    }
}

window.addEventListener('error', resizeObserverErrorHandler)

ReactDOM.render(
    window?.location?.href?.includes('/bpm') ? (
        <AppConfigurationBPM>
            <MainPageBPM />
        </AppConfigurationBPM>
    ) : (
        <AppConfiguration>
            <MainPage />
        </AppConfiguration>
    ),
    document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register()
